"use strict";

const Reflux = require("reflux");
const cx = require("classnames");

const RDStationIntegrationStore = require("../../stores/rd-station-integration-store");
const RDStationIntegrationActions = require("../../actions/rd-station-integration-actions");

const IntegrationTitle = require("app/screens/Integration/shared/components/integration-title");
const IntegrationLogo = require("app/screens/Integration/shared/components/integration-logo");
const logo = require("app/assets/images/rd_station.svg");

const Tooltip = require("app/shared/components/Tooltip/tooltip");
const Dropdown = require("app/shared/components/Dropdown/dropdown");
import Select from "react-select";

const TRIGGER_OPTIONS = [
  {
    id: "opportunity",
    name: "Após ser marcado como oportunidade"
  },
  {
    id: "converted",
    name: "Após converter em algum evento"
  }
];
const DEAL_OPTIONS = [
  {
    id: "person",
    name: "Sim, criar negócio relacionado à pessoa"
  },
  {
    id: "organization",
    name: "Sim, criar negócio relacionado à empresa"
  },
  {
    id: "disabled",
    name: "Não"
  }
];

const ACTIVATION_TOOLTIP = "Somente usuários do grupo administradores podem ativar ou desativar esta integração";
const SETTINGS_TOOLTIP = "Somente usuários do grupo administradores podem configurar esta integração";

const RDStationIntegration = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return RDStationIntegrationStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(RDStationIntegrationStore, this.setState);
    RDStationIntegrationActions.getStatus();
  },

  deactivate: function() {
    RDStationIntegrationActions.deactivate();
  },

  toggleSettings: function() {
    RDStationIntegrationActions.toggleSettings();
  },

  handleChangeTrigger: function({ value }) {
    this.handleChangeSettings({ event_type: value });
  },

  handleChangeEventIdentifiers: function(value) {
    this.handleChangeSettings({ event_identifiers: value });
  },

  handleChangeDeal: function({ value }) {
    this.handleChangeSettings({ deal_creation: value });
  },

  handleChangeSettings: function(diff) {
    let updatedSettings = Object.assign({}, this.state.settings, diff);

    RDStationIntegrationActions.changeSettings(updatedSettings);
  },

  saveSettings: function() {
    RDStationIntegrationActions.saveSettings();
  },

  isLoggedUserAdmin: function() {
    return window.loggedUserIsAdmin === "1";
  },

  renderButtons: function() {
    let label = "Carregando...";
    let disabled = !this.isLoggedUserAdmin();
    let href = null;
    let onClick = null;
    let showSettings = false;

    switch (this.state.activation) {
      case "active":
        label = "Desativar";
        onClick = this.deactivate;
        showSettings = true;

        break;

      case "inactive":
        label = "Ativar";
        href = this.state.authorizationUrl;

        break;

      case "deactivating":
        label = "Desativando...";
        disabled = true;
        showSettings = true;

        break;

      default:
        label = "Carregando...";
        disabled = true;
    }

    let activationClasses = cx("btn", "btn-primary", { disabled: disabled });
    let settingsClasses = cx("btn", "btn-default", "ml-10", { disabled: disabled });

    let activationButton =
      <a className={activationClasses} href={href} onClick={onClick} disabled={disabled}>
        {label}
      </a>

    let settingsButton =
      <button className={settingsClasses} onClick={this.toggleSettings} disabled={disabled}>
        Configurações
      </button>

    return (
      <div className="mt-20">
        {this.renderButton(activationButton, ACTIVATION_TOOLTIP)}
        {showSettings && this.renderButton(settingsButton, SETTINGS_TOOLTIP)}
      </div>
    );
  },

  renderButton: function(button, text) {
    if (this.isLoggedUserAdmin()) {
      return button;
    }

    return this.elementWithTooltip(button, text);
  },

  elementWithTooltip: function(element, text) {
    return (
      <Tooltip title={text} color={"darker"} bottom>
        {element}
      </Tooltip>
    );
  },

  renderSettings: function() {
    if (this.state.showSettings) {
      return (
        <div className="left-gray-border googleCalendar-settings-content">
          <div className="googleCalendar-settings-titleUnderline">
            <h3 className="c-333">Configurações</h3>
          </div>

          <div>
            <div className="googleCalendar-settings-topicTitle">
              Quando o lead deve ser enviado do RD para o Agendor?
            </div>

            <div className="row">
              <div className="col-md-6">
                <Dropdown
                  options={TRIGGER_OPTIONS}
                  handleCustomChange={this.handleChangeTrigger}
                  value={this.state.settings.event_type}
                />

                {this.renderEventSelection()}
              </div>
            </div>
          </div>

          <div>
            <div className="googleCalendar-settings-topicTitle">
              Deve ser criado um negócio no funil?
            </div>

            <div className="row">
              <div className="col-md-6">
                <Dropdown
                  options={DEAL_OPTIONS}
                  handleCustomChange={this.handleChangeDeal}
                  value={this.state.settings.deal_creation}
                />
              </div>
            </div>
          </div>

          <span className="bootstrap-agendor f-r mt-10">
            <button
              className="btn btn-primary"
              onClick={this.saveSettings}
              disabled={this.state.isSavingSettings}
            >
              Salvar
            </button>
          </span>
        </div>
      );
    } else {
      return null;
    }
  },

  renderEventSelection: function() {
    if (this.state.settings.event_type !== "converted") {
      return null;
    } else {
      return (
        <Select
          arrowRenderer={null}
          clearable={false}
          closeOnSelect={false}
          isLoading={this.state.isLoadingEventIdentifiers}
          labelKey="title"
          multi
          noResultsText="Nenhum evento correspondente"
          onChange={this.handleChangeEventIdentifiers}
          options={this.state.eventIdentifiers}
          placeholder="Quais eventos? (opcional)"
          value={this.state.settings.event_identifiers}
          valueKey="identifier"
        />
      );
    }
  },

  render: function() {
    return (
      <div>
        <IntegrationTitle title="Integração Agendor ↔ RD Station" />

        <div className="fieldContent">
          <IntegrationLogo
            logoHref="http://www.rdstation.com.br/?utm_source=agendor&utm_campaign=integracoes-agendor"
            logoSrc={logo}
          />

          <div className="left-gray-border integrationGuide">
            <h6>Quando um lead for convertido ou marcado como oportunidade no RD Station:</h6>
            <ul>
              <li className="integrationsDescription-item">
                Uma nova pessoa será cadastrada no Agendor com os dados do lead do RD Station
              </li>
              <li className="integrationsDescription-item">
                Um novo negócio será cadastrado no Agendor relacionado à pessoa criada
              </li>
            </ul>

            <h6>Quando um negócio for marcado como ganho no Agendor:</h6>
            <ul>
              <li className="integrationsDescription-item">
                O lead no RD Station terá o estágio do funil alterado para "Cliente"
              </li>
              <li className="integrationsDescription-item">
                O lead no RD Station terá uma nova venda registrada com o valor do negócio
              </li>
            </ul>

            <h6>Quando um negócio for marcado como perdido no Agendor:</h6>
            <ul>
              <li className="integrationsDescription-item">
                O lead no RD Station será desmarcado como oportunidade
              </li>
            </ul>

            {this.renderButtons()}
          </div>

          {this.renderSettings()}
        </div>
      </div>
    );
  }
});

module.exports = RDStationIntegration;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/RDStation/rd-station-integration.jsx